export default {"src":"/_next/static/media/exploitation.01f17926.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};